module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/sold-property-pin-78a6e65bc9382a31df1f962aca6b6209.svg";